import { colors } from "@material-ui/core";
import React from "react";

import useFirstDestinationOfType from "../../../hooks/useFirstDestinationOfType";
import { ConfigureDestinationsModal } from "../../modals/ConfigureDestinationsModal";
import { DestinationConfigRow } from "../shared/ConfigPageRow";

const CredentialsModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig = {},
}) => {
  const amplitude = useFirstDestinationOfType("amplitude") || { settings: {} };
  const { settings: allSettings, id } = amplitude;

  const limitSettings = ["apiKey"];

  if (!id) {
    limitSettings.push("preferAnonymousIdForDeviceId");
  }

  return (
    <ConfigureDestinationsModal
      limitSettings={limitSettings}
      open={open}
      includeHeader={true}
      settings={allSettings}
      dest={destination}
      onClose={onClose}
      onSave={handleUpdateConfigureDest}
      title="Credentials"
      existingConfig={existingConfig}
    />
  );
};

const CredentialsRow = ({ setConfigModalOpen }) => {
  const amplitude = useFirstDestinationOfType("amplitude") || { settings: {} };
  const { settings: allSettings } = amplitude;
  const idSet = !!allSettings.apiKey;

  return (
    <DestinationConfigRow
      name="Credentials"
      textColor={idSet ? "" : colors.red[600]}
      labelText={idSet ? "Configured" : "Not configured"}
      onOpenConfigModal={() => setConfigModalOpen("credentials")}
    />
  );
};

const ConfigurationModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig = {},
}) => {
  const amplitude = useFirstDestinationOfType("amplitude") || { settings: {} };
  const { settings: allSettings, id } = amplitude;

  const limitSettings = ["forceHttps", "useLogRevenueV2"];

  if (id) {
    limitSettings.push("preferAnonymousIdForDeviceId");
  }

  return (
    <ConfigureDestinationsModal
      limitSettings={limitSettings}
      open={open}
      settings={allSettings}
      dest={destination}
      onClose={onClose}
      onSave={handleUpdateConfigureDest}
      existingConfig={existingConfig}
    />
  );
};

const ConfigurationRow = ({ setConfigModalOpen }) => {
  const config = (useFirstDestinationOfType("amplitude") || { settings: {} })
    .settings;
  const enabled = !!config.apiKey;

  return (
    <DestinationConfigRow
      disabled={!enabled}
      name="Options"
      labelText="Optional"
      onOpenConfigModal={() => {
        if (enabled) {
          setConfigModalOpen();
        }
      }}
    />
  );
};

const EventTrackingModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig = {},
}) => {
  const allSettings = (
    useFirstDestinationOfType("amplitude") || { settings: {} }
  ).settings;

  return (
    <ConfigureDestinationsModal
      limitSettings={[
        "trackReferrer",
        "trackUtmProperties",
        "trackGclid",
        "saveParamsReferrerOncePerSession",
      ]}
      open={open}
      settings={allSettings}
      dest={destination}
      onClose={onClose}
      onSave={handleUpdateConfigureDest}
      title="Event Tracking"
      existingConfig={existingConfig}
    />
  );
};

const EventTrackingRow = ({ setConfigModalOpen }) => {
  const config = (useFirstDestinationOfType("amplitude") || { settings: {} })
    .settings;
  const enabled = !!config.apiKey;

  return (
    <DestinationConfigRow
      disabled={!enabled}
      name="Event Tracking"
      labelText="Optional"
      onOpenConfigModal={() => {
        if (enabled) {
          setConfigModalOpen();
        }
      }}
    />
  );
};

const BatchingModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig = {},
}) => {
  const allSettings = (
    useFirstDestinationOfType("amplitude") || { settings: {} }
  ).settings;

  return (
    <ConfigureDestinationsModal
      limitSettings={[
        "batchEvents",
        "eventUploadThreshold",
        "eventUploadPeriodMillis",
      ]}
      open={open}
      settings={allSettings}
      dest={destination}
      onClose={onClose}
      onSave={handleUpdateConfigureDest}
      title="Batching"
      existingConfig={existingConfig}
    />
  );
};

const BatchingRow = ({ setConfigModalOpen }) => {
  const config = (useFirstDestinationOfType("amplitude") || { settings: {} })
    .settings;
  const enabled = !!config.apiKey;

  return (
    <DestinationConfigRow
      disabled={!enabled}
      name="Batching"
      labelText="Optional"
      onOpenConfigModal={() => {
        if (enabled) {
          setConfigModalOpen();
        }
      }}
    />
  );
};

const CREDENTIALS = "CREDENTIALS";
const EVENT_TRACKING = "EVENT_TRACKING";
const BATCHING = "BATCHING";
const OPTIONS = "OPTIONS";

const Rows = {
  CREDENTIALS: CredentialsRow,
  OPTIONS: ConfigurationRow,
  EVENT_TRACKING: EventTrackingRow,
  BATCHING: BatchingRow,
};

const Modals = {
  CREDENTIALS: CredentialsModal,
  OPTIONS: ConfigurationModal,
  EVENT_TRACKING: EventTrackingModal,
  BATCHING: BatchingModal,
};

const RowOrder = [CREDENTIALS, OPTIONS, EVENT_TRACKING, BATCHING];

export default {
  Rows,
  RowOrder,
  Modals,
};
